import { NgModule } from '@angular/core';
import { HorizontalScrollDirective } from './horizontal-scroll.directive';

@NgModule({
    declarations: [
        HorizontalScrollDirective
    ],
    imports: [],
    exports: [
        HorizontalScrollDirective
    ]
})
export class NcHorizontalScrollModule { }